<div class="container-fluid padding-top padding-bottom margin-bottom"
     style="min-height: 120vh; margin-bottom: 150px;">
  <md-card style="margin-bottom: 120px;">
    <div *ngIf="client | async; else loading">
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-primary"
                  color="primary"
                  (click)="goBack()">Go Back</button>
        </div>
        <div class="review-loading float-right">
          <div *ngIf="afService.globalReviewsLoading">
            <md-spinner color="accent"></md-spinner>
            <!-- <p>Do no refresh the page until this stops.</p> -->
          </div>
        </div>

        <div class="col-md-12 text-center">
          <img src="{{ (client | async)?.logoUrl }}"
               class="logo"
               alt="">
          <h1>{{ (client | async)?.name}}</h1>

          <h3 style="color: #ffa000;font-weight: 400 !important;">Note: Calling this API costs $$$ for each batch
            submitted!</h3>
          <md-slide-toggle [(ngModel)]="clientData.reviewSettings.isActive"
                           (change)="toggleReviews($event)">
            Show Reviews on Facility Home
          </md-slide-toggle>
          <br>
          <br>
          <md-slide-toggle *ngIf="isProd; else notProd"
                           [(ngModel)]="clientData.reviewSettings.updateEachMonth"
                           (change)="toggleUpdateMonthly($event)">
            Update reviews automatically each month
          </md-slide-toggle>
          <ng-template #notProd>
            Update reviews automatically each month is for production only
          </ng-template>
          <br>
          <br>
          <md-slide-toggle [(ngModel)]="clientData.reviewSettings.sendReviewsSms"
                           (change)="toggleReviewsSms($event)">
            Enable reviews SMS
          </md-slide-toggle>
          <br>
          <br>
          <label for="minimumRating">Default Minimum Rating</label>
          <input pInputText
                 (change)="saveReviewSettings()"
                 id="minimumRating"
                 type="number"
                 [(ngModel)]="clientData.reviewSettings.minimumRating" />
          <br>
          <br>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Location</th>
                <th>Is Active</th>
                <th>Status</th>
                <th>Rating</th>
                <th>Total Reviews</th>
                <th>URLs</th>
                <th>Batch</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of locationStatus">
                <th scope="row"
                    style="color: #3D73B9">{{loc.locationName}}</th>
                <td>
                  <i *ngIf="loc?.isActive == true"
                     class="fa fa-check"
                     style="color: #12A983; font-size: 22px;"></i>
                  <i *ngIf="loc?.isActive == false"
                     class="fa fa-times"
                     style="color: #CC444B; font-size: 22px;"></i>
                </td>
                <td>
                  <i *ngIf="loc?.status == 'no-batch'"
                     class="fa fa-times"
                     style="color: #CC444B; font-size: 22px;"> No Batch</i>
                  <i *ngIf="loc?.status == 'done'"
                     class="fa fa-check"
                     style="color: #12A983; font-size: 22px;"></i>
                  <i *ngIf="loc?.status == 'submitted'"
                     class="fa fa-spinner"
                     style="color: #FFB844; font-size: 22px;"> Loading</i>
                  <i *ngIf="loc?.status == 'ready-to-submit'"
                     class="fa fa-thumbs-up"
                     style="color: #53CBAD; font-size: 22px;"> Ready</i>
                </td>

                <td>{{loc?.rating ? loc?.rating : 0}}</td>
                <td>{{loc?.totalReviews ? loc?.totalReviews : 0}}</td>
                <td class="url-td">
                  <p *ngFor="let url of loc?.urls"><small>{{url.url}}</small></p>
                </td>
                <td><button class="btn btn-default"
                          *ngIf="loc?.status == 'submitted' || loc?.status == 'done'"
                          (click)="fetchReviews(loc)">Get Reviews</button></td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <div class="row margin-bottom">
      <div class="col-md-6">
        <h5>Select a Location</h5>
        <br>
        <div class="btn-group full-width"
             dropdown>
          <button class="btn btn-default btn-lg full-width btnCheckbox dropdown-toggle"
                  dropdownToggle
                  placement="right"
                  style="box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0);margin-right: 20px;"
                  type="button">
            {{selectedLocation ? selectedLocation.name : 'Select a Location'}}
          </button>
          <ul class="dropdown-menu dropdown-menu-right ng-star-inserted full-width"
              *dropdownMenu
              role="menu">

            <li role="menuitem"
                *ngFor="let location of locations | async">
              <a class="dropdown-item"
                 (click)="selectLocation(location)"
                 style="cursor: pointer;">
                <h5
                    style="padding: 0;-webkit-margin-before: 0em;-webkit-margin-after: 0em;font-size: 16px; font-weight: 600;">
                  {{location.name}}</h5>
                {{location?.address}}
                <br> {{location.address2}}
              </a>
              <hr style="margin-top: 0;margin-bottom: 0;">
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-6">
        <div *ngIf="selectedLocation"
             class="text-center selected-location-card margin-top">
          <h5 style="margin-top: -10px;">{{selectedLocation?.name}}</h5>
          <p>{{selectedLocation?.address}}</p>
          <p>{{selectedLocation?.address2}}</p>
        </div>
      </div>
    </div>

    <div class="row"
         *ngIf="selectedLocation">

      <div class="col-md-12 padding-bottom text-center">
        <md-slide-toggle [(ngModel)]="facilityReviewsData.isActive"
                         (change)="updateFacilityReviewsToggle($event)">
          <h4>Reviews for {{selectedLocation.name}}</h4>
        </md-slide-toggle>
      </div>
      <div class="col-md-12"
           *ngIf="facilityReviewsData.isActive && facilityReviewsData.activeIndex != 4">
        <p-steps [model]="items"
                 [(activeIndex)]="facilityReviewsData.activeIndex"
                 styleClass="steps-custom"
                 [readonly]="true"></p-steps>
      </div>
    </div>

    <div class="row margin-top"
         *ngIf="facilityReviewsData.isActive && facilityReviewsData.activeIndex > 0 && facilityReviewsData.activeIndex != 4">
      <div class="col-md-12">
        <button class="btn btn-default"
                (click)="facilityReviewsData.activeIndex = facilityReviewsData.activeIndex-1">Back</button>
        <button class="btn btn-default"
                *ngIf="facilityReviewsData.batchId > 0 && facilityReviewsData.activeIndex == 0"
                (click)="facilityReviewsData.activeIndex = facilityReviewsData.activeIndex+1">Forward</button>
      </div>
    </div>
    <div class="row padding-bottom text-center"
         *ngIf="facilityReviewsData.isActive && facilityReviewsData?.activeIndex == 1">
      <div class="col-md-8 col-md-offset-2">

        <h4>Batch ID: {{ facilityReviewsData?.batchId }}</h4>
        <p>Review Profile URL </p><a href="http://apidocs.brightlocal.com/#constructing-google+-urls"
           target="_blank">HELP</a>
        <button class="btn btn-default"
                (click)="addGoogleUrl()">Add Google URL</button>
        <br>
        <br>
        <div *ngIf="error"
             class="error"
             role="alert">
          <span class="glyphicon glyphicon-exclamation-sign"
                aria-hidden="true"></span>
          <span class="sr-only">Error:</span> {{error }}
        </div>
        <input class="full-width"
               [(ngModel)]="newProfileUrl"
               pInputText
               name="new-review" />
        <br>
        <br>
        <button class="btn btn-primary float-right ladda-button"
                [ladda]="afService.isLoading"
                (click)="addReviewUrl()">Add URL to batch</button>
      </div>

      <div class="col-md-6 col-md-offset-3 margin-top"
           *ngIf="facilityReviewsData.urls.length >= 1">
        <a class="date-button"
           (click)="readyToSubmit()">Ready to Submit</a>
      </div>
    </div>

    <div *ngIf="facilityReviewsData.isActive && facilityReviewsData?.activeIndex == 0"
         class="row margin-bottom">
      <div class="col-md-6 col-md-offset-3 margin-top margin-bottom">
        <button class="btn btn-primary ladda-button"
                [ladda]="afService.isLoading"
                (click)="createNewBatch()"
                style="margin-left: auto;margin-right: auto;display: block;">Create New Batch with BrightLocal</button>
      </div>
    </div>
    <div *ngIf="facilityReviewsData.isActive && facilityReviewsData?.activeIndex == 4"
         class="row">
      <div class="col-md-6 col-md-offset-3 margin-top margin-bottom">
        <img src="https://firebasestorage.googleapis.com/v0/b/storpug-dev.appspot.com/o/person-raising-both-hands-in-celebration_1f64c.png?alt=media&token=bc420b0f-c85b-4bc3-a9d5-e2aec122bdde"
             style="margin-left: auto;margin-right:auto;display: block;margin-bottom: 30px;"
             alt="">


        <button class="btn btn-accent ladda-button"
                [ladda]="afService.isLoading"
                (click)="createNewBatchWithSameData()"
                style="margin-left: auto;margin-right: auto;display: block;">Retreive new Reviews for the Same
          URLs</button>
        <br>
        <button class="btn btn-default"
                [ladda]="afService.isLoading"
                (click)="createNewBatch()"
                style="margin-left: auto;margin-right: auto;display: block;">Start Over</button>
      </div>
    </div>


    <div class="text-center"
         *ngIf="showLoading">
      <h2>Loading Results</h2>
      <h2>Stay on this page until finished.</h2>
      <md-spinner></md-spinner>
    </div>

    <div class="row"
         *ngIf="facilityReviewsData.isActive && facilityReviewsData.urls.length >= 1">

      <div class="col-md-10 col-md-offset-1">
        <table class="table">
          <thead>
            <tr>
              <th>URL</th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let url of facilityReviewsData.urls; let i = index;">
              <td>{{url.url}}</td>
              <!-- <th scope="row">
                <button class="btn btn-default float-right">Remove {{i}}</button>
              </th> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="facilityReviewsData?.activeIndex == 2"
           class="col-md-6 col-md-offset-3 margin-top">
        <button class="btn btn-primary ladda-button"
                [ladda]="afService.isLoading"
                (click)="submitBatch()"
                style="margin-left: auto;margin-right: auto;display: block;">Submit Batch</button>
      </div>
    </div>
  </md-card>

  <ng-template #loading>
    <div class="spinner">
      <md-spinner color="accent"></md-spinner>
    </div>
  </ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/facility-reviews/facility-reviews.component.html